const IP_URL = process.env.REACT_APP_NODE_API_URL

export const authLogin = async (email, password) => {
    try {
        const response = await fetch(IP_URL + "api_login/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      console.log('Los datos son: ', data)
      return data;
    } catch (error) {
      //console.error("Error al iniciar sesión", error);
      var aux = 0;
    }
  }; 